export default "__VITE_ASSET__685c1a6d__"